<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld :msg="Token" />
    <!-- <p >Type: {{ Type }}.</p> -->
    <p v-show="userName">userName: {{ userName }}.</p>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

import { getUserInfo } from '@/api/user.js'
import { switchLevels } from '@/api/case.js'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
  data ()  {
    return {
      msg:'',
      Type:  this.$route.params.Type,
      Token: this.$route.params.Token,
      BusinessType : this.$route.params.BusinessType,
      CaseId: this.$route.params.CaseId,
      Status: this.$route.params.Status
      // userName: this.userName,
    }
  },
  created(){
    console.log(this.$store)

    },
  methods: {
    refresh ()  {
      // this.$store.dispatch("user/setUser", user);
      console.info(this.Token)
      localStorage.setItem('pc_Authorization', this.Token)
      getUserInfo(this.Token).then(res => {
        if (res && res.data.success) {
          this.$store.dispatch('setUser', res.data)
          // this.$router.push({name: '/case', params: {Type: this.Type}});
          // this.$router.push('/case/' + this.Type)

          localStorage.setItem('user', JSON.stringify(res.data.data))
          if(this.BusinessType == null || Object.keys(this.BusinessType).length==0) {
            // this.$router.push('/indexMenu')
            this.$router.push('/case')
          }else if (this.CaseId == null || Object.keys(this.CaseId).length==0) {
            this.$router.push('/' + this.BusinessType)
          }else{
            this.$router.push('/' + this.BusinessType + '/' + this.Status + '/' + this.CaseId)
          }

        } else {
          this.$Message.error('数据错误')
        }
      })
    }
  },
  mounted () {
    this.refresh()
  },
  computed: {
    ...mapState({
      userName: state => state.user.userName
    })
  }
}
</script>
